import type { LanguageCode } from '@kairelo/shared';
import type { Catalogue } from './messages/en.js';
import { en } from './messages/en.js';
import { de } from './messages/de.js';
import { nl } from './messages/nl.js';
import { hr } from './messages/hr.js';

/**
 * Interface catalogues.
 *
 * Only languages with a complete, reviewed translation appear here. The
 * language picker offers every language the *message translator* supports — a
 * far longer list — and says plainly which of those also translate the
 * interface.
 *
 * That distinction is deliberate. Shipping a half-translated interface and
 * calling it support is worse than an honest fallback to English: a user who
 * sees their language listed reasonably expects the whole product in it.
 *
 * Adding a language: write `messages/<code>.ts` typed as `Catalogue`, and add it
 * below. The type makes any missing key a build failure, so a catalogue is
 * either complete or it does not compile.
 */
export const CATALOGUES: Partial<Record<LanguageCode, Catalogue>> = {
  en,
  de,
  nl,
  hr,
};

/** Languages whose interface is fully translated. */
export const TRANSLATED_LANGUAGES = Object.keys(CATALOGUES) as LanguageCode[];

export function isInterfaceTranslated(language: LanguageCode): boolean {
  return TRANSLATED_LANGUAGES.includes(language);
}
